<template>
	<div>
		<v-sheet
			v-if="enableSearch"
			class="px-3 pt-6 pb-3"
		>
			<v-text-field
				v-model="searchQuery"
				:label="searchLabel"
				:hide-details="(true)"
				prepend-inner-icon="mdi-magnify"
				rounded
				clearable
				filled
			/>
		</v-sheet>

		<v-list
			v-if="filteredItems.length"
			flat
		>
			<template
				v-for="(item, index) in filteredItems"
			>
				<v-list-item
					:key="item.id"
					:href="(item.redirect_url) ? item.redirect_url : null"
					:target="(item.redirect_url) ? '_blank' : null"
					@click="itemClick(item)"
				>
					<v-list-item-icon v-if="item[iconSrc]">
						<v-icon
							:color="(item[iconColorSrc]) ? item[iconColorSrc] : 'accent'"
						>
							{{item[iconSrc]}}
						</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title v-html="item[titleSrc]" />
						<v-list-item-subtitle v-html="item[summarySrc]" />
					</v-list-item-content>
					<v-list-item-action v-if="item[metaSrc]">
						<v-list-item-action-text v-html="item[metaSrc]" />
					</v-list-item-action>
				</v-list-item>
				<v-divider
					v-if="index != filteredItems.length - 1" :key="('divider-' + index)"
					:inset="(item.icon && item.icon.length > 0)"
				/>
			</template>
		</v-list>
		<p
			v-else
			class="pa-6"
		>
			{{noResultsText}}
		</p>
	</div>

</template>

<script>

export default {
	name: 'FilterableList',
	data: () => ({
		searchQuery: '',
	}),
	props: {
		items: {
			type: Array,
			default: () => {
				return []
			}
		},
		iconSrc: {
			type: String,
			default: () => {
				return 'icon'
			}
		},
		iconColorSrc: {
			type: String,
			default: () => {
				return 'icon_color'
			}
		},
		titleSrc: {
			type: String,
			default: () => {
				return 'title'
			}
		},
		summarySrc: {
			type: String,
			default: () => {
				return 'summary'
			}
		},
		metaSrc: {
			type: String,
			default: () => {
				return 'date'
			}
		},
		enableRedirect: {
			type: Boolean,
			default: () => {
				return true
			}
		},
		enableSearch: {
			type: Boolean,
			default: () => {
				return true
			}
		},
		searchLabel: {
			type: String,
			default: () => {
				return 'Haku'
			}
		},
		noResultsText: {
			type: String,
			default: () => {
				return 'Ei hakutuloksia.'
			}
		},
	},
	computed: {
		filteredItems () {
			if (this.searchQuery) {
				let regex = new RegExp(this.searchQuery, 'i')

				return this.items.filter(item => {
					if (regex.test(item.title) || regex.test(item.summary)) return true
				})
			} else {
				return this.items
			}
		},
	},
	methods: {
		itemClick (item) {
			if (item.redirect_url) return

			this.$emit('itemClick', item)
		}
	},
}
</script>
<style lang="scss">

.v-list-item__title {
	overflow: visible;
	white-space: normal;
}

</style>